var _ = require("underscore");
var debug = require("debug")("models:BndPageQueryModel");
var Backbone = require("backbone");

// BndPageQueryModel : recherche bnd dans une page, ne supporte pas le mode collapse ni les aggregations de l'api car pas besoin dans le contexte reader
module.exports = Backbone.Model.extend({
    pv5api: null,

    defaults: {
        query: null,  // query string
        from: 0,
        size: 10,
        total: null,
        sort: null,
        filters: null,
        highlight: false,
        highlightWordPosition: false,
        highlightNumberOfFragments: 4,
        highlightFragmentSize: 200,
        hits: null
    },

    initialize: function (attributes, options) {
        var T = this;

        Backbone.Model.prototype.initialize.apply(T, arguments);

        _.extend(T, options);
        debug("initialize");
        T.set(
            {
                hits: new Backbone.Collection(),          // results collection
            }
        );
    },

    search: function () {
        return this.fetch();
    },

    // overide sync to call elasticsearch
    sync: function (method, model, options/*, defaults*/) {
        var T = this;

        // only read is allowed
        if (method !== "read") {
            throw new Error("method not allowed " + method);
        }

        var data = T.toJSON();
        delete (data.hits);
        delete (data.total);

        // JSON request options
        var params = {
            type: "POST",
            dataType: "json",
            jsonp: false,
            contentType: "application/json",
            crossDomain: true,
            data: JSON.stringify(data),
            url: model.pv5api + "/bnd-search/page"
        };

        // ajout token
        if (T.token) {
            if (!params.headers) {
                params.headers = {};
            }
            params.headers["x-access-token"] = T.token;
        }

        params = _.extend(params, options);
        var xhr = Backbone.ajax(params);
        model.trigger("request", model, xhr, options);
        return xhr;
    },

    // override fetch method to update local collections
    // instead of recreating the model
    fetch: function (defaults, options) {
        //console.log("fetch");
        options = options ? _.clone(options) : {};
        defaults = defaults || {};

        var T = this;
        var success_cb = options.success;
        var error_cb = options.error;

        T.fetching = true;

        options.success = function (res, status, xhr) {

            T.fetched = true;
            T.fetching = false;

            if (_.isFunction(T.parse)) {
                res = T.parse(res, xhr);
            }

            T.get("hits").reset(res.hits);

            if (success_cb) {
                success_cb(T, res);
            }
            T.trigger("sync", T, res, options);
        };
        options.error = function (xhr) {
            T.fetching = false;
            if (error_cb) {
                error_cb(T, xhr, options);
            }
            T.trigger("error", T, xhr, options);
        };

        return T.sync("read", T, options, defaults);
    },

    /*parse: function (response) {
        return response;
    },*/

});


//////////////////
// WEBPACK FOOTER
// ./src/models/bnd-page-query-model.js
// module id = 62
// module chunks = 0